import { AxiosMode } from '@/axiosModel';
import { DEFAULT_ENABLE_WATERMARK } from '@/constants';
import type { UserMeta } from '@/types';

const apis = new AxiosMode();
const AIPICTUREBOOK_API_BASE = `${AxiosMode.API_HOST}/api/aipicturebook`;

function normalizeBoolean(value: unknown, fallback: boolean): boolean {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1') return true;
    if (normalized === 'false' || normalized === '0' || normalized === '') return false;
  }
  return fallback;
}

export async function fetchUserMeta(): Promise<UserMeta> {
  const postData: { key?: string } = {};

  // if (key) {
  //   postData['key'] = key;
  // }

  const { req } = apis.post({ postData, remotePath: `${AIPICTUREBOOK_API_BASE}/get-user-meta` });

  const res: any = await req;

  return {
    enable_watermark: normalizeBoolean(res.data.enable_watermark, DEFAULT_ENABLE_WATERMARK),
    first_export: normalizeBoolean(res.data.first_export, true),
    hasOnboarding: normalizeBoolean(res.data.hasOnboarding, false)
  };
}

export async function setUserMeta(data: UserMeta): Promise<void> {
  const { req } = apis.post({
    postData: data,
    remotePath: `${AIPICTUREBOOK_API_BASE}/set-user-meta`
  });

  await req;
}
